import { useEffect, useRef } from 'react';

import { useAnalyticsEvents } from '@atlaskit/teams-app-internal-analytics';
import {
	hasProductPermission,
	useProductPermissions,
} from '@atlaskit/teams-app-internal-product-permissions';

function useContainerPermissionsAnalyticsEvent(cloudId?: string, userId?: string) {
	const { loading, data, error } = useProductPermissions({
		userId,
		cloudId,
		permissionsToCheck: {
			jira: ['CREATE_PROJECT'],
			loom: ['write'],
			confluence: ['CREATE_SPACE'],
		},
	});
	const hasFiredRef = useRef(false);
	const { fireEvent } = useAnalyticsEvents();
	useEffect(() => {
		if (loading || !data || Object.keys(data).length === 0 || error || hasFiredRef.current) {
			return;
		}
		const attributes = {
			canCreateConfluenceContainer: data
				? hasProductPermission(data, 'confluence', ['CREATE_SPACE'])
				: false,
			canCreateLoomContainer: data ? hasProductPermission(data, 'loom', ['write']) : false,
			canCreateJiraContainer: data ? hasProductPermission(data, 'jira', ['CREATE_PROJECT']) : false,
		};
		fireEvent('track.containerPermissions.succeeded', {
			canCreateConfluenceContainer: attributes.canCreateConfluenceContainer || false,
			canCreateLoomContainer: attributes.canCreateLoomContainer || false,
			canCreateJiraContainer: attributes.canCreateJiraContainer || false,
		});
		hasFiredRef.current = true;
	}, [loading, data, error, fireEvent]);
}

export { useContainerPermissionsAnalyticsEvent };
